import { Routes } from '@angular/router';
import { FailedComponent } from './failed/failed.component';
// import { HomeComponent } from './home/home.component'; // REMOVED: Dead code
// import {DetailsComponent} from './details/details.component';
import { ProfileComponent } from './profile/profile.component';
import { MsalGuard } from '@azure/msal-angular';
import { ChatComponent } from './components/chat/chat.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { PromptComponent } from './prompt/prompt.component';
import { DatatableComponent } from '../app/datatable/datatable.component';
import { adminGuard } from './guards/admin.guard';
import { GenerateImageComponent } from './generate-image/generate-image.component';
import { PopupShowcaseComponent } from './popup-showcase/popup-showcase.component';

export const routes: Routes = [
    {
        path: 'hcp-chatbot',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: '',
        component: PromptComponent,
        canActivate: [MsalGuard]
    },
  

    {
        path: 'p',
        component: PromptComponent
    },

    {
        path: 's',
        component: SidebarComponent
    },

    {
        path: 'login-failed',
        component: FailedComponent
    },

    {
        path: 'ui',
        component: ChatComponent
    },

    {
        path: 'pro',
        component: ProfileComponent
    },
     {
        path: 'admin',
        component: DatatableComponent,
        canActivate: [MsalGuard, adminGuard]
    },
    {
        path: 'generate-image',
        component: GenerateImageComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'popup-showcase',
        component: PopupShowcaseComponent,
        canActivate: [MsalGuard]
    },
       {
        path: '**',
        component: ProfileComponent
    },
];
